<template>
  <v-btn
    icon
    @click="toggle"
  >
    <v-icon>{{ isDark ? mdiWeatherSunny : mdiWeatherNight }}</v-icon>
  </v-btn>
</template>

<script>
import { mdiWeatherNight, mdiWeatherSunny } from '@mdi/js';
import { THEME } from '@/constants';

export default {
  name: 'TheThemeToggler',
  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
  },
  created() {
    this.mdiWeatherSunny = mdiWeatherSunny;
    this.mdiWeatherNight = mdiWeatherNight;
  },
  methods: {
    toggle() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      const mode = this.$vuetify.theme.dark ? THEME.MODE.DARK : THEME.MODE.LIGHT;
      localStorage.setItem(THEME.STORAGE_KEY, mode);
    },
  },
};
</script>
